import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./phoneInput.css";

/**
 * Themed international phone input with flag dropdown.
 * Props: value, onChange(e164String), defaultCountry (iso2), placeholder, "data-testid", name
 */
export default function ThemedPhoneInput({ value, onChange, defaultCountry, placeholder = "Enter phone number", ...rest }) {
  return (
    <PhoneInput
      international
      countryCallingCodeEditable={false}
      defaultCountry={defaultCountry || "NG"}
      value={value}
      onChange={(v) => onChange(v || "")}
      placeholder={placeholder}
      className="afri-phone-input"
      numberInputProps={{ "data-testid": rest["data-testid"] }}
      {...rest}
    />
  );
}
